// extracted by mini-css-extract-plugin
module.exports = {"token":"PartnerFreeToken_token__3VFd9"};